export function generateUniqueId(prefix: string = ''): string {
  const randomPart = Math.random().toString(36).substring(2, 10); // Random 8-char alphanumeric
  const timestamp = Date.now().toString(36); // Encoded timestamp
  return `${prefix}_${timestamp}_${randomPart}`;
}
